import { $, $$, isMobile, reducedMotion } from '../../nth-ms26-core/js/env';

// Ảnh/video do GS sửa trong static/home-kv.html.twig. Có video: KV 5s → video lặp; không có: carousel ảnh.
export function initHomeKv(frame) {
  const root = $('[data-home-kv]', frame);
  if (!root) return;
  const slides = $$('[data-kv-slide]', root);
  // Vẫn hiện đúng ảnh đầu khi GS xóa/đổi thứ tự các <picture>.
  slides.forEach((slide, i) => slide.classList.toggle('is-active', i === 0));
  const video = $('[data-trailer]', root);
  const hasVideo = Boolean(video && video.dataset.src);
  if (slides.length < 2 && !hasVideo) return;
  const delay = Number(root.dataset.homeKv) || 5000;
  const html = document.documentElement;
  let index = 0;
  let timer = 0;
  let generation = 0;
  let inView = false;
  let videoShown = false;
  let playRequested = false;

  const visible = () => !document.hidden && html.classList.contains('is-loaded') &&
    !reducedMotion.matches && (isMobile() ? inView : frame.classList.contains('is-active'));

  const keepKv = () => {
    videoShown = false;
    playRequested = false;
    frame.classList.remove('is-trailer');
  };
  const playVideo = () => {
    timer = 0;
    if (!visible()) return;
    const token = generation;
    playRequested = true;
    const playing = video.play();
    if (playing && playing.catch) playing.catch(() => {
      if (token === generation) keepKv();
    });
  };
  if (hasVideo) {
    video.muted = true;
    video.addEventListener('playing', () => {
      // Một lệnh play cũ có thể hoàn tất sau khi người xem đã rời frame.
      if (!visible() || !playRequested) {
        video.pause();
        return;
      }
      videoShown = true;
      frame.classList.add('is-trailer');
    });
    video.addEventListener('error', () => {
      clearTimeout(timer);
      timer = 0;
      keepKv();
    });
  }

  const prepare = (slide) => {
    const img = $('img', slide);
    if (!img) return Promise.resolve(false);
    img.loading = 'eager';
    const loaded = img.complete ? Promise.resolve() : new Promise((resolve) => {
      const done = () => {
        img.removeEventListener('load', done);
        img.removeEventListener('error', done);
        resolve();
      };
      img.addEventListener('load', done);
      img.addEventListener('error', done);
    });
    return loaded.then(async () => {
      if (!img.naturalWidth) return false;
      if (img.decode) await img.decode().catch(() => {});
      return img.naturalWidth > 0;
    });
  };

  const schedule = () => {
    clearTimeout(timer);
    timer = 0;
    if (!visible()) {
      if (hasVideo) {
        playRequested = false;
        video.pause();
      }
      return;
    }
    if (hasVideo) {
      // Bắt đầu tải sau ảnh LCP; KV che video đến khi có sự kiện playing.
      if (!video.getAttribute('src')) {
        video.preload = 'auto';
        video.src = video.dataset.src;
      }
      if (videoShown) playVideo();
      else timer = setTimeout(playVideo, delay);
      return;
    }
    const token = generation;
    const next = (index + 1) % slides.length;
    const ready = prepare(slides[next]);
    timer = setTimeout(async () => {
      timer = 0;
      const loaded = await ready;
      if (token !== generation || !visible()) return;
      if (loaded) {
        slides[index].classList.remove('is-active');
        slides[next].classList.add('is-active');
        index = next;
      }
      schedule();
    }, delay);
  };
  const sync = () => {
    generation += 1; // vô hiệu lần tải ảnh còn chờ khi rời màn/ẩn tab
    schedule();
  };

  document.addEventListener('nth:frame', sync);
  document.addEventListener('visibilitychange', sync);
  reducedMotion.addEventListener('change', sync);
  if (isMobile()) {
    new IntersectionObserver(([entry]) => {
      inView = entry.isIntersecting;
      sync();
    }, { threshold: 0.3 }).observe(frame);
  }
  if (!html.classList.contains('is-loaded')) {
    const observer = new MutationObserver(() => {
      if (!html.classList.contains('is-loaded')) return;
      observer.disconnect();
      sync();
    });
    observer.observe(html, { attributes: true, attributeFilter: ['class'] });
  }
  sync();
}
